import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import EuroIcon from '@mui/icons-material/Euro';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import { PATH_COSTS, PATH_COSTS_NEW } from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { CostList } from '../../components/CostList';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const CostsPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Costs);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Coûts')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_COSTS,
            label: 'coûts',
            key: 'costs',
          },
        ]}
      />
      <PageTitle title="Liste des Coûts" />
      <CostList />
      <SpeedDial
        actions={[
          {
            id: 'createCost',
            icon: <EuroIcon />,
            name: 'Créer Coût',
            to: PATH_COSTS_NEW,
          },
        ]}
        title="Actions possibles sur les Coûts"
      />
    </>
  );
};
